/* eslint-disable react/forbid-component-props */
import { productCardContainerSX } from '@/components/blocks/DpLibrary/DpProductCard/styles/container';
import { productCardImagerSX } from '@/components/blocks/DpLibrary/DpProductCard/styles/image';
import {
	productCardCategorySX,
	productCardDiscountSX,
	productCardPriceSX,
	productCardTitleSX,
} from '@/components/blocks/DpLibrary/DpProductCard/styles/typography';
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { ProductCardSelectColor } from '@/components/blocks/ProductCardSelectColor';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { ProductRibbons } from '@/components/blocks/Ribbons';
import { ProductType, Ribbon } from '@/data/types/Product';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';
import { Box, Grid, Skeleton, Typography } from '@mui/material';

export const DpProductCard = ({
	title,
	category,
	image,
	discount,
	price,
	seo,
	ribbons = [],
	showPrice,
	variants,
	partNumber,
	onSelectColor,
}: {
	title: string;
	category: string;
	image: string;
	discount?: string;
	price: string;
	seo?: string;
	ribbons?: Ribbon[];
	showPrice?: boolean;
	variants: ProductType[];
	partNumber: string;
	onSelectColor?: (variant: ProductType) => void;
}) => {
	const sxPrice = productCardPriceSX(discount !== undefined);

	const sortedRibbons = mergeRibbonsForProduct(ribbons);
	return (
		<Grid className="product-card-container" sx={productCardContainerSX}>
			<Linkable className="product-card-linkable" href={`${seo}`} draggable={false}>
				<Box className="product-card-frame" sx={{ position: 'relative' }}>
					<RenderProductImg
						fullImageRaw={image}
						render={(image) => (
							<Img
								className="product-card-image"
								src={image}
								draggable={false}
								alt={title}
								sx={productCardImagerSX}
							/>
						)}
					/>
					<ProductRibbons ribbons={sortedRibbons} />
				</Box>

				<Grid padding={'10px 15px 10px 15px'} marginTop={'-5px'}>
					<Grid
						container
						display={'flex'}
						flexDirection={'column'}
						justifyContent={'space-between'}
					>
						<Box>
							<ProductCardSelectColor
								variants={variants}
								selectedPartNumber={partNumber}
								sx={{ mb: '6px' }}
								onSelectColor={onSelectColor}
							/>
							<Grid item sx={{ mb: '4px' }}>
								<Typography sx={productCardTitleSX}>{title}</Typography>
							</Grid>
							<Grid item sx={{ mb: '11px' }}>
								<Typography sx={productCardCategorySX}>{category}</Typography>
							</Grid>
							<Grid
								item
								sx={{
									display: 'flex',
									flexDirection: 'row',
								}}
							>
								{discount && showPrice ? (
									<Typography sx={productCardDiscountSX}>{discount}</Typography>
								) : null}
								<Typography sx={sxPrice}>
									{showPrice ? price : <Skeleton variant="rectangular" width={100} height={20} />}
								</Typography>
							</Grid>
						</Box>
					</Grid>
				</Grid>
			</Linkable>
		</Grid>
	);
};
